/* import __COLOCATED_TEMPLATE__ from './ai-assist-options.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import ToolbarAiAssist from 'embercom/components/inbox2/composer/toolbar-ai-assist';
import { inject as service } from '@ember/service';
import type CopilotApi from 'embercom/services/copilot-api';
import type CopilotFrameService from 'embercom/services/copilot-frame-service';
import { FrameComposerType } from 'embercom/lib/frame-adapter';

// eslint-disable-next-line @intercom/intercom/no-component-inheritance
export default class AiAssistOptions extends ToolbarAiAssist {
  @service declare copilotFrameService: CopilotFrameService;
  @service declare copilotApi: CopilotApi;

  // We don't currently support paywalls within the Copilot Frame so lets
  // remove the paywalled options from the list.
  get options() {
    return super.options.filter((option) => !option.paywalled);
  }

  get isPreviewMode() {
    return this.copilotApi.isPreviewMode;
  }

  get externalComposerNotFound() {
    return !this.copilotFrameService.composerVisible;
  }

  get isExternalComposerEmpty() {
    return !this.copilotFrameService.composerHasContent;
  }

  get isSalesforceEmailComposer() {
    return this.copilotFrameService.composerType === FrameComposerType.SALESFORCE_EMAIL_COMPOSER;
  }

  get isDisabled() {
    return this.isPreviewMode || this.externalComposerNotFound || this.isExternalComposerEmpty;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Copilot::AiAssistOptions': typeof AiAssistOptions;
    'standalone/copilot/ai-assist-options': typeof AiAssistOptions;
  }
}
